module.exports = __webpack_public_path__ + "static/keep-small-strong-lockup-6477a5e8b0b33760db421daeace11d81.png";